"use client";

import { Shield, Target, DollarSign } from "lucide-react";
import { Separator } from "@/components/ui/separator";
export default function WhyChooseUs() {
  const features = [{
    icon: Shield,
    title: "Technická preciznost",
    description: "Každý projekt provádíme s maximální odborností a důrazem na detaily, což zaručuje dlouhodobou kvalitu a spolehlivost."
  }, {
    icon: Target,
    title: "Prokazatelné výsledky",
    description: "Naše práce mluví za nás – dodáváme měřitelné výsledky, které chrání vaši nemovitost a zvyšují její hodnotu."
  }, {
    icon: DollarSign,
    title: "Transparentní ceny",
    description: "Žádné skryté poplatky. Poskytujeme jasné cenové kalkulace a férové podmínky pro všechny naše služby."
  }];
  return <section id="proč-zvolit-nás" className="dark bg-background text-foreground py-24 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-0">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className="relative group">
                <div className="flex flex-col items-center text-center px-8 py-12">
                  <div className="mb-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02]">
                    <Icon className="w-16 h-16 text-primary" strokeWidth={1.5} />
                  </div>
                  
                  <h3 className="text-2xl font-semibold mb-4 text-foreground">
                    {feature.title}
                  </h3>
                  
                  <p className="text-muted-foreground leading-relaxed max-w-sm">
                    {feature.description}
                  </p>
                </div>

                {i < features.length - 1 && <Separator orientation="vertical" className="absolute right-0 top-1/2 -translate-y-1/2 h-3/4 bg-muted/30 hidden md:block" />}
              </div>;
        })}
        </div>
      </div>
    </section>;
}